// ════════════════════════════════════════════════════════════════════════════
// BlobBackground Component
// ════════════════════════════════════════════════════════════════════════════
// Animated gradient blobs that float behind content.
// Creates the distinctive Appointment Flo ambient background.

interface BlobBackgroundProps {
  /** Custom colors to override the default AF palette (for tenant branding) */
  colors?: string[];
}

export function BlobBackground({ colors }: BlobBackgroundProps) {
  // Default to AF brand palette if no custom colors provided
  const blobColors = colors || [
    "var(--color-af-900)",
    "var(--color-af-500)",
    "var(--color-af-300)",
    "var(--color-af-700)",
    "var(--color-af-500)",
  ];

  return (
    <div className="blob-background" aria-hidden="true">
      <div
        className="blob blob-1"
        style={colors ? { background: blobColors[0] } : undefined}
      />
      <div
        className="blob blob-2"
        style={colors ? { background: blobColors[1] } : undefined}
      />
      <div
        className="blob blob-3"
        style={colors ? { background: blobColors[2] } : undefined}
      />
      <div
        className="blob blob-4"
        style={colors ? { background: blobColors[3] } : undefined}
      />
      <div
        className="blob blob-5"
        style={colors ? { background: blobColors[4] } : undefined}
      />
    </div>
  );
}

export default BlobBackground;
